var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProductForm',{class:!_vm.loading && 'disable-ske',attrs:{"value":_vm.initialData,"isShowing":_vm.isShowing,"productWebsites":_vm.productWebsites,"product":_vm.product},on:{"save":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }